import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import Joyride from "react-joyride";
import { mediaQueryPoint, useMediaQuery } from "../../../utils/hooks";
import { useSelector } from "react-redux";
import { curStateAccount, curStateHome } from "../../../Redux/selector";
import { useTranslation } from "react-i18next";

// handleSkip: gọi khi tour đi hết bước cuối (kể cả khi user chạm ra ngoài
// overlay) để nơi gọi đánh dấu tour đã xong. Trước đây nó nằm ở tham số thứ 3 của
// forwardRef — React chỉ truyền (props, ref) nên luôn là hàm rỗng, và chạm ra
// ngoài ở bước cuối chỉ tắt joyride: tour biến mất nhưng state vẫn "đang chạy"
// (step ≥ 1), popup manager bị chặn tới khi reload.
const AuctionIntroTour = forwardRef(({ dataTour = [], handleSkip = () => { } }, ref) => {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.lg}px)`);
  const [stepIndex, setStepIndex] = useState(0);
  const [run, setRun] = useState(false);
  const { typeIntroTour } = useSelector(curStateHome);
  const selectorAccount = useSelector(curStateAccount);
  const { t } = useTranslation();

  useEffect(() => {
    const handleLoad = () => {
      // console.log("Trang web đã tải xong!");
      setRun(true);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.onload = handleLoad;
    }

    return () => {
      window.onload = null; // Cleanup khi component unmount
    };
  }, []);

  // khi đổi item thì scroll đến item đó
  useEffect(() => {
    if (!run || !dataTour.length) return;

    const currentStep = dataTour[stepIndex];

    if (!currentStep?.target) return;

    const element = document.querySelector(currentStep.target);

    if (!element) return;

    const topOffset =
      element.getBoundingClientRect().top + window.scrollY - 200;

    window.scrollTo({
      top: topOffset,
      behavior: "smooth",
    });
  }, [stepIndex, run, dataTour]);

  const goToNextStep = () => {
    if (stepIndex < dataTour.length - 1) {
      setStepIndex(stepIndex + 1);
      return;
    }
    setRun(false);
    handleSkip();
  };

  // click ra ngoài overlay thì chuyển tour
  useEffect(() => {
    if (!run) return;

    const handleClickOutside = (event) => {
      const classList = event.target?.classList;
      if (
        classList?.contains("react-joyride__overlay") ||
        classList?.contains("react-joyride__spotlight")
      ) {
        goToNextStep();
      }
    };

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
    // stepIndex: goToNextStep đọc bước hiện tại — thiếu thì listener giữ giá trị cũ.
  }, [run, dataTour, stepIndex]); // eslint-disable-line react-hooks/exhaustive-deps


  useImperativeHandle(ref, () => ({
    // next() {
    //   setStepIndex((prev) => {
    //     if (prev < dataTour.length - 1) {
    //       return prev + 1;
    //     }

    //     setRun(false);
    //     return prev;
    //   });
    // },

    next() {
      goToNextStep();
    },

    prev() {
      setStepIndex((prev) => Math.max(prev - 1, 0));
    },

    start() {
      setStepIndex(0);
      setRun(true);
    },

    stop() {
      setRun(false);
    },
  }));
  const handleJoyrideCallback = (data) => {
    setStepIndex(data.index);

    if (
      data.type === "step:after" ||
      data.type === "step:start" ||
      data.type === "tour:start"
    ) {
      const step = data.step;
      if (step?.target) {
        const element = document.querySelector(step.target);
        if (element) {
          const topOffset =
            element.getBoundingClientRect().top + window.scrollY - 200;
          window.scrollTo({
            top: topOffset,
            behavior: "smooth",
          });
        }
      }
    }
  };
  if (dataTour.length !== 1) {
    return (
      <Joyride
        steps={dataTour}
        run={run}
        continuous
        showSkipButton={true}
        disableScrolling={true}
        scrollToFirstStep={true}
        hideCloseButton
        // callback={handleJoyrideCallback}
        stepIndex={stepIndex}
        styles={{
          options: {
            zIndex: 9999,
          },
          // buttonNext:
          //   stepIndex === dataTour.length - 1 ? { display: "none" } : {},
          buttonNext: { display: "none" },
          buttonBack: { display: "none" },
          buttonClose: { display: "none" },
          buttonSkip: { display: "none" },
        }}
      />
    );
  }

  if (typeIntroTour.step === -1) {
    return <></>;
  }


  return (
    <Joyride
      steps={dataTour}
      run={run}
      stepIndex={stepIndex}
      disableScrolling
      scrollToFirstStep
      continuous
      hideCloseButton
      disableOverlayClose
      showSkipButton={true}
      locale={{
        next: t("user_guide.next"),
        skip: t("user_guide.skip"),
      }}
      callback={(data) => {
        if (data.action === "next" || data.action === "prev") {
          setStepIndex(data.index + (data.action === "next" ? 1 : -1));
        }
      }}
      styles={{
        options: {
          zIndex: 9999,
        },
        buttonNext: { display: "none" },
        buttonBack: { display: "none" },
        buttonClose: { display: "none" },
        buttonSkip: { display: "none" },
      }}
    />
  );
});

export default AuctionIntroTour;
